import {
  Controller,
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import React from "react";

import {
  SwitchV2,
  type SwitchV2Props,
} from "src/components/SwitchV2/SwitchV2.tsx";
import {
  ControlLabelV2,
  type ControlLabelV2Props,
} from "src/components/ControlLabelV2/ControlLabelV2.tsx";
import { composeRefs } from "@exonn/hooks";

export type SwitchFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  name: TName;
} & Pick<ControlLabelV2Props, "helperText" | "label" | "isLoading"> &
  Omit<SwitchV2Props, "ref" | "defaultValue"> & {
    defaultValue?: boolean;
  } & Omit<ControllerProps<TFieldValues, TName>, "render">;

// todo: forward ref
export const SwitchField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: SwitchFieldProps<TFieldValues, TName>,
) => {
  const {
    name,
    control,
    disabled,
    helperText,
    rules,
    shouldUnregister,
    defaultValue,
    label,
    ...restProps
  } = props;

  return (
    <ControlLabelV2
      key={name}
      helperText={helperText}
      label={label}
      disabled={disabled}
      control={
        <Controller
          key={name}
          control={control}
          rules={rules}
          // disabled={disabled}
          shouldUnregister={shouldUnregister}
          defaultValue={defaultValue}
          name={name}
          render={({ field: { name, value, onChange, onBlur, ref } }) => {
            const {
              onChange: onChangeProp,
              onBlur: onBlurProp,
              ...restComponentProps
            } = restProps;

            return (
              <SwitchV2
                ref={composeRefs(ref)}
                name={name}
                disabled={disabled}
                checked={value}
                onBlur={(event) => {
                  onBlur();
                  onBlurProp?.(event);
                }}
                onChange={(e) => {
                  onChange(e);
                  onChangeProp?.(e);
                }}
                {...restComponentProps}
              />
            );
          }}
        />
      }
    />
  );
};
